var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger f-10 tres-puntos d-block"},[_vm._v(" "+_vm._s(_vm.texto)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }